export default __webpack_public_path__ + "static/media/grade-banner1.95312411.jpg";